var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "编辑",
        visible: _vm.dialog,
        width: "50%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "custom-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "right",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "开票发票号", prop: "kpfph" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入开票发票号" },
                model: {
                  value: _vm.form.kpfph,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "kpfph", $$v)
                  },
                  expression: "form.kpfph",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否开票", prop: "sfkp" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.sfkp,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "sfkp", $$v)
                    },
                    expression: "form.sfkp",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }